import { useTranslation } from 'next-i18next';
import { FileUploader } from '@bridebook/ui';
import type { IS3File } from '@bridebook/ui/src/types';

type IProps = {
  onFileAddErrorAnalytics?: (...args: any) => void;
  onMultipleUploadFinish?: (files: IS3File[]) => void;
  onUploadFinish?: (file: IS3File) => void;
  preprocess?: (file: File, next: Function) => void;
  isMobile: boolean;
  multiple?: boolean;
  directory?: string;
  bucket?: string;
  supplierPhotos?: boolean;
};

const PhotoUpload = ({
  isMobile,
  onFileAddErrorAnalytics,
  onMultipleUploadFinish,
  onUploadFinish,
  preprocess,
  multiple,
  directory,
  bucket,
  supplierPhotos,
}: IProps) => {
  const { t } = useTranslation('common');
  const uploadLabel = !isMobile
    ? t('photo.upload.label.mobile', {
        count: multiple ? 2 : 1,
      })
    : t('photo.upload.label.desktop', {
        count: multiple ? 2 : 1,
      });

  const maxFileSize = supplierPhotos ? 11 : 5; // MB
  const acceptFileTypes = ['image/png', 'image/jpeg'];
  const minImageWidth = 600;

  return (
    <FileUploader
      allowTranslation
      bucket={bucket}
      onFileAddErrorAnalytics={onFileAddErrorAnalytics}
      maxFileSize={maxFileSize}
      uploadLabel={uploadLabel}
      acceptFileTypes={acceptFileTypes}
      minImageWidth={minImageWidth}
      onMultipleUploadFinish={onMultipleUploadFinish}
      onUploadFinish={onUploadFinish}
      multiple={multiple}
      directory={directory}
      preprocess={preprocess}
      enableCloudflareImages
    />
  );
};

export default PhotoUpload;
